export default function Input({
  type,
  placeholder,
  name,
  register,
  errors,
  rules,
  label,
  className,
  labelClassName,
  disabled = false,
  labelDisabled = false,
  onClick,
  onChange,
  inputContainerClass,
  ...rest
}: {
  type: string;
  placeholder: string;
  name: string;
  register: any;
  errors: any;
  rules?: any;
  className?: string;
  label?: string | null | React.ReactNode;
  labelClassName?: string;
  disabled?: boolean;
  labelDisabled?: boolean;
  onClick?: (() => void) | ((...args: any[]) => any);
  onChange?: (...args: any[]) => any;
  inputContainerClass?: string;
}) {
  return (
    <div>
      <div className={inputContainerClass}>
        {label && (
          <label
            className={` text-xs md:text-base ${labelClassName} ${
              labelDisabled ? "hidden md:block" : ""
            }`}
          >
            {label} {rules?.required && <span className="text-red-600">*</span>}
          </label>
        )}
        <input
          onClick={onClick}
          onChange={(e) => {
            onChange?.(e);
          }}
          type={type}
          placeholder={placeholder}
          className={`${errors[name] && "input-invalid"} ${className}`}
          disabled={disabled}
          {...register(name, rules)}
          {...rest}
        />
      </div>
      {errors[name] && (
        <small className="mt-1.5 text-red-600 block">
          {errors[name].message || "This field is required"}
        </small>
      )}
    </div>
  );
}
